export default __webpack_public_path__ + "static/media/img6.4f7987bf.png";